import React, { useEffect, useState, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import API_ROUTES from "src/config/api";
import Axios from 'axios';
import { Auth } from "aws-amplify";

const StatusItem = ({ loading, statusCheck, description, successText, failureText, section }) => {
  if (loading === true) {
    return (
      <tr>
        <td className="border px-4 py-2 text-left">{description}</td>
        <td className="w-[200px] border px-4 py-2 text-center bg-amber-300 relative">
          <div className='absolute w-[150px] z-0'>
            <Skeleton count={1} height="25px" className="m-0 p-1 bg-amber-300" />
          </div>
          <div className='z-10 relative'>
            Running
          </div>
        </td>
      </tr>
    )
  }


  return (
    <tr>
      <td className="border px-4 py-2 text-left">{description}</td>
      <td className={`w-[200px] border px-4 py-2 ${statusCheck === true ? 'bg-green-200' : 'bg-red-200'} text-center`}>
        {statusCheck === true ? successText : failureText}
      </td>
    </tr>
  );
};

const LedgerHealhtCheck = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const { organisation } = useSelector((state) => state);

  const getData = useCallback(async () => {
    setLoading(true);

    const user = await Auth.currentAuthenticatedUser();

    const result = await Axios(
      API_ROUTES.ledger['ledger:healthchecks'](),
      {
        method: 'post',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
        data: {
          organisation: organisation.organisation
        }
      }
    );

    setData(result.data.data);
    setLoading(false);
  });

  useEffect(() => {
    getData();
  }, [organisation.organisation]);

  return (
    <div>

      {
        loading === false && (
          data?.ammendments_balance === false ||
          data?.batches_align_with_transactions === false ||
          data?.disbursals_summing === false ||
          data?.disbursal_in_manual_review === false ||
          data?.ledger_balanced === false ||
          data?.paid_out_settled === false ||
          data?.settled_in_ledger === false
        ) && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Warning!</strong>
            <span className="block sm:inline"> There are some issues with this organisations ledger</span>
          </div>
        )
      }

      <table className="table-auto w-full">

        <tbody>

          <h2 className='text-xl pl-2 mb-3 font-extrabold'>Ammendments & Adjustments</h2>

          <StatusItem loading={loading} statusCheck={data?.ammendments_balance} successText="Balanced" failureText="Not Balanced" section="Ammendments & Adjustments" description="All credits & debits are balanced" />

          <h2 className='text-xl pl-2 mt-3 mb-3 font-extrabold'>Batches</h2>

          <StatusItem loading={loading} statusCheck={data?.batches_align_with_transactions} successText="Balanced" failureText="Not Balanced" section="Batch" description="Batch totals align with transaction totals" />

          <h2 className='text-xl pl-2 mt-3 mb-3 font-extrabold'>Disbursals</h2>

          <StatusItem loading={loading} statusCheck={data?.disbursals_summing} successText="Balanced" failureText="Not Balanced" section="Disbursals" description="All concur with batch totals" />
          <StatusItem loading={loading} statusCheck={data?.disbursal_in_manual_review} successText="Balanced" failureText="Not Balanced" section="Disbursals" description="None in manual review" />

          <h2 className='text-xl pl-2 mt-3 mb-3 font-extrabold'>Ledger Balance</h2>

          <StatusItem loading={loading} statusCheck={data?.ledger_balanced} successText="Balanced" failureText="Not Balanced" section="Ledger" description="Balance aligns with pending disbursals" />

          <h2 className='text-xl pl-2 mt-3 mb-3 font-extrabold'>Transactions</h2>

          <StatusItem loading={loading} statusCheck={data?.paid_out_settled} successText="Balanced" failureText="Not Balanced" section="Paid out transactions" description="All paid out transactions balance" />
          <StatusItem loading={loading} statusCheck={data?.settled_in_ledger} successText="Balanced" failureText="Not Balanced" section="Settled transactions" description="All settled transactions are in ledger" />

        </tbody>
      </table>
    </div>
  )

}

export default LedgerHealhtCheck;